import { useParams, useNavigate } from "react-router-dom";
import TicketLeftSideMenuCard from "../../../components/ticket/TicketLeftSideMenuCard";
import TicketRightSideMenu from "../../../components/ticket/TicketRightSideMenu";
import TicketPaneOpen from "../../../components/ticket/TicketPaneOpen";
import TicketListInfoCard from "../../../components/ticket/TicketListInfoCard";
import { useDetailTicketQuery } from "../../../Services/ticket/TicketDetail";
import { useEffect, useState, useRef } from "react";
import ReactModal from "react-modal";
import CreateTaskModal from "../../../components/ticket/ticketListInfo/CreateTaskModal";
import { useCreateTaskMutation } from "../../../Services/ticket/CreateTask";
import { useTaskQuery } from "../../../Services/ticket/Task";
import {
  useAuditTrailQuery,
  useGetForwardedAuditTrailCountQuery,
} from "../../../Services/ticket/Audit-Trail";
import { useTicketPaginationQuery } from "../../../Services/ticket/TicketList";
import { INCOMING_CALL } from "../../../constants";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { toast } from "react-toastify";
import SLMetricsModal from "../../../components/ticket/TicketSLMetricsModal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AssessmentIcon from "@mui/icons-material/Assessment";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import GroupIcon from "@mui/icons-material/Group";
import "./TicketListInfo.scss";
import CreateChildTicket from "../../../components/ticket/CreateChildTicket";
import OurTeamModal from "../../../components/ticket/OurTeamModal";
import KnowledgeBaseModal from "../../../components/ticket/KnowledgeBaseModal";

const TicketListInfo = () => {
  const params = useParams();
  const uuid = params.uuid;
  const [currentTicketId, setCurrentTicketId] = useState(uuid);
  const { data, refetch  , isFetching} = useDetailTicketQuery(currentTicketId);
  const [liftingKey, setLiftingKey] = useState([]);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [dependancyValue, setDependancyValue] = useState("");
  const [storeLabel, setStoreLabel] = useState([]);
  const [channel, setChannel] = useState(() => {
    const storedChannel = sessionStorage.getItem(
      `channel_${sessionStorage.getItem("selectedOption")}`,
    );
    return storedChannel === "All" ? "" : storedChannel || "";
  });
  const selectedOption =
    sessionStorage.getItem("selectedOption") || "ticketListView";
  const ticketListViewPageSize =
    sessionStorage.getItem("ticketListViewPageSize") || "5";
  const ticketStandardPageSize =
    sessionStorage.getItem("ticketStandardPageSize") || "5";
  const ticketCardViewPageSize =
    sessionStorage.getItem("ticketCardViewPageSize") || "5";
  const [isSLMetricsModalOpen, setIsSLMetricsModalOpen] = useState(false);
  const [isKnowledgeBaseModalOpen, setIsKnowledgeBaseModalOpen] =
    useState(false);
  const [isOurTeamModalOpen, setIsOurTeamModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState<any>(() => {
    const savedPage = sessionStorage.getItem("ticketCurrentPage");
    return Number(savedPage);
  });
  const [liftUiData, setLiftUiData] = useState(0);
  const [value, setValue] = useState(() => {
    return sessionStorage.getItem("ticketTabValue") || "All";
  });
  const [selectedWorkFlow, setselectedWorkFlow] = useState(
    sessionStorage.getItem("selectedWorkFlow") || "",
  );
  const [selectedTeamId, setSelectedTeamId] = useState(() => {
    const selectedTeamIdFromSession = sessionStorage.getItem("selectedTeamId");
    const userRole = localStorage.getItem("user_role");
    const userId = localStorage.getItem("User_Id");

    if (selectedTeamIdFromSession) {
      return selectedTeamIdFromSession;
    }

    if (userRole === "admin") {
      return "My Team";
    }

    if (userRole === "agent" || userRole === "manager") {
      return userId;
    }

    return null; // Fallback value if none of the conditions are met
  });
  const [selectedFilterAndValue1, setSelectedFilterAndValue1] = useState<any>(
    () => {
      const sessionData = sessionStorage.getItem("selectedFilterAndValue");
      return sessionData
        ? JSON.parse(sessionData)
        : {
            action__contact__email__icontains: "",
            action__assignee__username__icontains: "",
            title__icontains: "",
            created: "",
            id__icontains: "",
            merchant_id: "",
          };
    },
  );
  const initialStoreKey =
    sessionStorage.getItem("storeKey") || (liftUiData ? "active" : "All");
  const [storeKey, setStoreKey] = useState(initialStoreKey);
  const callActive = localStorage.getItem(INCOMING_CALL) === "true";
  const [direction, setDirection] = useState(null);
  const [isTicketLoading, setIsTicketLoading] = useState(false);

  const [createTask] = useCreateTaskMutation({});
  const {
    data: taskData,
    refetch: refetchTask,
    isLoading,
  } = useTaskQuery(uuid);

  const { data: auditTrailData, refetch: refetchAuditTrailData } =
    useAuditTrailQuery(uuid);

  const {
    data: auditTrailForwardedData,
    refetch: refetchAuditTrailForwardedData,
  } = useGetForwardedAuditTrailCountQuery(uuid);
  const { data: fetchedData, refetch: refetchTicket } =
    useTicketPaginationQuery(
      {
        currentPage,
        pageSize:
          selectedOption === "ticketListView"
            ? ticketListViewPageSize
            : selectedOption === "ticketStandardView"
            ? ticketStandardPageSize
            : ticketCardViewPageSize,
        value,
        selectedWorkFlow,
        selectedTeamId,
        selectedFilterAndValue1,
        liftingKey,
        storeKey,
        channel,
      },
      { skip: !selectedWorkFlow || callActive },
    );

  const navigate = useNavigate(); // Initialize useNavigate

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isChildTicketModalOpen, setIsChildTicketModalOpen] =
    useState<boolean>(false);
  const [getAllStatus, setGetAllStatus] = useState<any>([]);
  const [paneOpen, setPaneOpen] = useState<String>("LeadInformation");

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "550px",
    },
  };
  const customModalStyles1 = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%", // Default to full width
      maxWidth: "850px", // Max width for larger screens
      height: "80%",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const afterOpenModal = () => {
    // subtitle.style.color = '#f00'
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openChildTicketModal = () => {
    setIsChildTicketModalOpen(true);
  };
  const afterOpenChildTicketModal = () => {
    // subtitle.style.color = '#f00'
  };
  const closeChildTicketModal = () => {
    setIsChildTicketModalOpen(false);
  };
  const handleBackButtonClick = () => {
    navigate(-1); // Navigate back to the previous page
  };

  const handleButtonClick = async (event, direction) => {
    event.preventDefault();
    setDirection(direction);
    setIsTicketLoading(true);
    const recordsPerPage: any =
      selectedOption === "ticketCardView"
        ? ticketCardViewPageSize
        : selectedOption === "ticketStandardView"
        ? ticketStandardPageSize
        : ticketListViewPageSize;
    const tickets = fetchedData?.results;
    const totalRecords = fetchedData?.count || 0;
    const totalPages = Math.ceil(totalRecords / recordsPerPage);
    const currentIndex = tickets?.findIndex(
      (ticket) => ticket.id === currentTicketId,
    );

    if (direction === "next") {
      if (currentIndex < tickets?.length - 1) {
        const nextTicketId = tickets[currentIndex + 1].id;
        setCurrentTicketId(nextTicketId);
        navigate(`/ticket/information/${nextTicketId}`, {
          replace: true,
        });
        setConfirmationModalOpen(false);
      } else if (currentPage < totalPages) {
        setCurrentPage((prevPage) => {
          const newPage = prevPage + 1;
          sessionStorage.setItem("ticketCurrentPage", newPage);
          return newPage;
        });
        setConfirmationModalOpen(false);
      } else {
        toast.warning("No more tickets available.");
        setConfirmationModalOpen(false);
      }
    } else if (direction === "previous") {
      if (currentIndex > 0) {
        const previousTicketId = tickets[currentIndex - 1]?.id;
        setCurrentTicketId(previousTicketId);
        navigate(`/ticket/information/${previousTicketId}`, {
          replace: true,
        });
      } else if (currentPage > 1) {
        setCurrentPage((prevPage) => {
          const newPage: any = prevPage - 1;
          sessionStorage.setItem("ticketCurrentPage", newPage);
          return newPage;
        });
      } else {
        toast.warning("No previous tickets available.");
      }
    }
    setIsTicketLoading(false);
  };

  useEffect(() => {
    const refetchData = async () => {
      setIsTicketLoading(true);
      const result = await refetchTicket();
      const newData = result?.data;

      if (direction === "next" && newData?.results?.length > 0) {
        const firstTicketId = newData.results[0]?.id;
        setCurrentTicketId(firstTicketId);
        navigate(`/ticket/information/${firstTicketId}`, {
          replace: true,
        });
      } else if (direction === "previous" && newData?.results?.length > 0) {
        const lastTicketId = newData.results[newData.results.length - 1]?.id;
        setCurrentTicketId(lastTicketId);
        navigate(`/ticket/information/${lastTicketId}`, {
          replace: true,
        });
      }
      setIsTicketLoading(false);
    };

    if (direction) {
      refetchData();
    }
  }, [currentPage]);

  const mainContentRef = useRef<HTMLDivElement>(null); // Create a reference to the component

  const scrollToTop = () => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(() => {
    const refetchData = async () => {
      setIsTicketLoading(true);
      await refetchTicket(); // Assuming this function refetches the data

      if (direction === "next" || direction === "previous") {
        setPaneOpen("LeadInformation"); // Set the active tab
      }

      setIsTicketLoading(false);

      setDirection(null);
    };

    if (direction) {
      setPaneOpen("LeadInformation");
      refetchData();
    }
  }, [direction]);

    useEffect(() => {
    setLoading(isFetching);
  }, [isFetching]);


  const slaMetricsData: any = {
    sla_breach_logs: data?.sla_breach_logs || [],
    id: data?.id || "N/A",
    priority: data?.priority || "N/A",
    created: data?.created || "",
    status_type: data?.status_type || "",
  };
  
  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <LoadingSpinner />
        </div>
      ) : (
        <div className="ticket-list-info-container">
          <div className="ticket-info-wrapper">
            <div className="ticket-info-sticky-header">
            <div className="ticket-info-header">
              <div className="header-left">
                <button className="back-button" onClick={handleBackButtonClick}>
                  <ArrowBackIcon />
                </button>
                <h2 className="page-title">Ticket information</h2>
              </div>

              <div className="header-right">
                <button
                  className="action-button sl-metrics-btn"
                  onClick={() => setIsSLMetricsModalOpen(true)}
                
                >
                  <AssessmentIcon fontSize="small" />
                  <span>SL Matrix</span>
                </button>
                {/* <button
                  className="action-button knowledge-base-btn"
                  onClick={() => setIsKnowledgeBaseModalOpen(true)}
                  disabled
                  style={{ opacity: 0.5, cursor: "not-allowed" }}
                >
                  <MenuBookIcon fontSize="small" />
                  <span>Knowledge base</span>
                </button>
                <button
                  className="action-button our-team-btn"
                  onClick={() => setIsOurTeamModalOpen(true)}
                  disabled
                  style={{ opacity: 0.5, cursor: "not-allowed" }}
                >
                  <GroupIcon fontSize="small" />
                  <span>Our team</span>
                </button> */}
                <button
                  className="create-task-button"
                  onClick={openModal}
                  disabled
                  style={{ opacity: 0.5, cursor: "not-allowed" }}
                >
                  <AddIcon fontSize="small" />
                  Create task
                </button>
              </div>
            </div>

            <div className="navigation-controls">
              <button
                className="nav-button"
                onClick={(event) => handleButtonClick(event, "previous")}
                title="Previous Ticket"
              >
                <ArrowBackIosIcon fontSize="small" />
              </button>
              <button
                className="nav-button"
                onClick={(event) => handleButtonClick(event, "next")}
                title="Next Ticket"
              >
                <ArrowForwardIosIcon fontSize="small" />
              </button>
            </div>
            </div>

            <ReactModal
              isOpen={isModalOpen}
              onAfterOpen={afterOpenModal}
              onRequestClose={closeModal}
              style={customModalStyles}
              contentLabel="Create Task"
              shouldCloseOnOverlayClick={false}
            >
              <CreateTaskModal
                closeModal={closeModal}
                ticket={data}
                createTask={createTask}
                refetchTask={refetchTask}
              />
            </ReactModal>

            <ReactModal
              isOpen={isChildTicketModalOpen}
              onRequestClose={closeChildTicketModal}
              style={customModalStyles1}
              contentLabel="New Ticket"
            >
              <CreateChildTicket
                closeModal={closeChildTicketModal}
                refetch={refetch}
                uuid={uuid}
              />
            </ReactModal>
            {/* SL Matrix Modal */}
            <SLMetricsModal
              isOpen={isSLMetricsModalOpen}
              onClose={() => setIsSLMetricsModalOpen(false)}
              ticketData={slaMetricsData}
            />

            {/* Knowledge Base Modal */}
            <KnowledgeBaseModal
              isOpen={isKnowledgeBaseModalOpen}
              onClose={() => setIsKnowledgeBaseModalOpen(false)}
            />

            {/* Our Team Modal */}
            <OurTeamModal
              isOpen={isOurTeamModalOpen}
              onClose={() => setIsOurTeamModalOpen(false)}
            />

            {isTicketLoading ? (
              <div className="loading-container">
                <LoadingSpinner />
              </div>
            ) : data?.length === 0 ? (
              <div className="no-data">No data available.</div>
            ) : (
              <div className="ticket-content-layout">
                <div className="left-sidebar">
                  <TicketLeftSideMenuCard tickets={data} />
                  {/* <SLMetrics
                    timeLeft={timeLeft}
                    dispositionTimeLeft={dispositionTimeLeft}
                    workflowTime={workflowTime}
                    statusType={statusType}
                  />
                  <TicketRightSideMenu
                    auditTrailForwardedData={auditTrailForwardedData}
                    setPaneOpen={setPaneOpen}
                  /> */}
                </div>

                <div className="main-contentttt" ref={mainContentRef}>
                  <TicketListInfoCard
                    tickets={data}
                    refetch={refetch}
                    refetchAuditTrailData={refetchAuditTrailData}
                    setGetAllStatus={setGetAllStatus}
                    refetchAuditTrailForwardedData={
                      refetchAuditTrailForwardedData
                    }
                    openChildTicketModal={openChildTicketModal}
                    dependancyValue={dependancyValue}
                    storeLabel={storeLabel}
                  />
                  <TicketPaneOpen
                    tickets={data}
                    refetch={refetch}
                    taskData={taskData}
                    refetchTask={refetchTask}
                    isLoading={isLoading}
                    refetchAuditTrailForwardedData={
                      refetchAuditTrailForwardedData
                    }
                    paneOpen={paneOpen}
                    setPaneOpen={setPaneOpen}
                    setConfirmationModalOpen={setConfirmationModalOpen}
                    confirmationModalOpen={confirmationModalOpen}
                    handleButtonClick={handleButtonClick}
                    auditTrailForwardedData={auditTrailForwardedData}
                    setDependancyValue={setDependancyValue}
                    setStoreLabel={setStoreLabel}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default TicketListInfo;
